import { render } from "./AsModalCriticalRenew.vue?vue&type=template&id=4e58dadd&ts=true"
import script from "./AsModalCriticalRenew.vue?vue&type=script&lang=ts"
export * from "./AsModalCriticalRenew.vue?vue&type=script&lang=ts"

import "./AsModalCriticalRenew.vue?vue&type=style&index=0&id=4e58dadd&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__